//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibLogo',
  props: {
    height: {
      type: String,
      default: 'auto'
    },
    fill: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    smallPadding: {
      type: Boolean,
      default: false
    },
    square: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: '',
      required: true
    },
    width: {
      type: String,
      default: 'auto'
    }
  },
  computed: {
    logoPath: function logoPath() {
      return "img: ".concat(this.src);
    },
    styles: function styles() {
      // if small padding set, ignore prop styling
      if (this.smallPadding) {
        return '';
      }

      return {
        width: this.width,
        height: this.height
      };
    }
  }
};